/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Overwrite_NoneInputs */

const cs_ebr_overwrite_none = /** @type {(inputs: Ebr_Overwrite_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechat hodnoty z CRM`)
};

const en_ebr_overwrite_none = /** @type {(inputs: Ebr_Overwrite_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep CRM values`)
};

/**
* | output |
* | --- |
* | "Keep CRM values" |
*
* @param {Ebr_Overwrite_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_overwrite_none = /** @type {((inputs?: Ebr_Overwrite_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Overwrite_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_overwrite_none(inputs)
	return cs_ebr_overwrite_none(inputs)
});